import { translation } from "@/api"

export default class TranslateServices {


  async trans (data, applyList) {
    if (window.$i18n.locale === 'ko') { return false }

    // 데이터 가공
    const obj = await this.setupDataform(data)
    const unique = obj.unique

    let sendForm = {
      language: [window.$i18n.locale],
      messages: [...obj.messages]
    }
    let resObj = {}

    // 테스트용
    // resObj = await this.decodingData(obj.messages, unique)

    try {
      // 원본
      const transRes = await translation(sendForm)
      console.log('transRes: ', transRes)

      if (transRes.data.status === 'success') {
        resObj = await this.decodingData(transRes.data.messages, unique)
      } else {
        resObj = {status: false}
      }

    } catch(e) {
      // console.log(e)
      resObj = {status: false, error: e.message}

    } finally {
      this.applyTrans(resObj, unique, applyList)
    }
    return true
  }

  // 데이터 가공
  setupDataform (data) {
    const object = new Promise((res, rej) => {
      const unique = data.unique
      const prop = data.property
      const items = data.data
      let dataForm = {
        unique: unique,
        messages: []
      }

      if (Array.isArray(items)) {
        items.forEach(d => {
          prop.forEach(p => {
            if (d[unique]) {
              dataForm.messages.push({id: `${d[unique]}_${p}`, text: d[p]})
            } else if (Array.isArray(data.unique)) {
              let id = data.unique.map(x => d[x])
              dataForm.messages.push({id: `${id}_${p}`, text: d[p]})
            } else {
              dataForm.messages.push({id: `${unique}_${p}`, text: d[p]})
            }
          })
        })
      } else if (typeof items === 'object') {
        prop.forEach(p => {
          dataForm.messages.push({id: `${items[unique]}_${p}`, text: items[p]})
        })
      }


      res(dataForm)
    })
    return object
  }

  // 데이터 재성형
  decodingData (data, unique) {
    const object = new Promise((res, rej) => {
      let response = {
        status: true,
        messages: []
      }
      data.forEach(d => {
        const param = d.id.split('_')
        let obj = {}
        if (Array.isArray(unique)) {
          unique.forEach((uni, idx) => {
            obj[uni] = param[0].split(',')[idx]
          })
        } else {
          obj[unique] = param[0]
        }
        obj['field'] = param[1]
        obj['text'] = d.text
        response.messages.push(obj)
      })

      res(response)
    })
    return object
  }

  // 번역 데이터 적용
  applyTrans (data, unique, applyData) {
    if (data.status) {
      data.messages.forEach(m => {
        if (Array.isArray(applyData)) {
          applyData.forEach(async (x, index) => {
            if(Array.isArray(unique)) {
              const find = await new Promise(res => {
                let length = unique.length
                let matched = 0
                unique.forEach(uni => {
                  if (x[uni] === m[uni]) { matched++ }
                  if (length === matched) {
                    res(m)
                  }
                })

              })
              if (find) {
                // 원본
                x[find.field] = find.text
              }
            } else if (typeof x[unique] === 'number') {
              if (x[unique] === Number(m[unique])) { x[m.field] = m.text }
            } else {
              if ( index === Number(m[unique]) ) { x[m.field] = m.text }
            }
          })

        } else if (typeof applyData === 'object') {
          // 테스트용
          // if (applyData[unique] === Number(m[unique])) { applyData[m.field] = '번역_'+m.text }

          // 원본
          if (applyData[unique] === Number(m[unique])) { applyData[m.field] = m.text }
        }
      })
    }
  }

}
